// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

const uri = "api/sainc/myAccount/salesGoalInfo";

type SalesGoalInformationResult = {
    uri: string;
    annualSalesGoal: number;
    annualSalesGoalDisplay: string;
    yearToDate: number;
    yearToDateDisplay: string;
    properties: any;
};

export async function getSalesGoalInformation() {
    try {
        const result = await get<SalesGoalInformationResult>(`${uri}`);
        return {
            successful: true,
            uri: result.uri,
            annualSalesGoal: result.annualSalesGoal,
            annualSalesGoalDisplay: result.annualSalesGoalDisplay,
            yearToDate: result.yearToDate,
            yearToDateDisplay: result.yearToDateDisplay,
            properties: result.properties,
        };
    } catch (error) {
        return {
            successful: false,
            uri: "",
            annualSalesGoal: 0,
            annualSalesGoalDisplay: "",
            yearToDate: 0,
            yearToDateDisplay: "",
            properties: {},
        };
    }
}
